import Mounter from 'shared/utils/mounter';
import DevelopersGreenhouseRoot from 'developers_greenhouse_root/index';

Mounter.mountWhenReady({
  DevelopersGreenhouseRoot,
});
